import type { TemplateVariant } from '#shared/utils/template-files'
import { getTemplateDownloadUrl } from '#shared/utils/template-files'
import { triggerBrowserDownload } from '~/utils/browser/download'

type TemplateDownloadSurface = 'detail' | 'list' | 'related'

interface DownloadableTemplate {
  id: string
  title?: string | null
}

export function useTemplateDownload() {
  const { track } = usePendo()

  function trackTemplateDownload(template: DownloadableTemplate, variant: TemplateVariant, surface: TemplateDownloadSurface) {
    track('ContentDownloaded', { type: 'template', contentId: template.id, title: template.title ?? '', variant, surface })
  }

  function downloadMainTemplate(template: DownloadableTemplate, surface: Exclude<TemplateDownloadSurface, 'detail'>) {
    const variant: TemplateVariant = 'mal'
    trackTemplateDownload(template, variant, surface)
    triggerBrowserDownload(getTemplateDownloadUrl(template.id, variant))
  }

  return {
    trackTemplateDownload,
    downloadMainTemplate,
  }
}
